import type { GetServerSideProps } from "next";

import { loadPageWithGlobal } from "@shared/api";

import { getCulturalObjectPage } from "@/_pages/cultural-objects/api";
import type { CulturalObject } from "@/_pages/cultural-objects/model";
import { SingleCulturalObjectPage } from "@/_pages/cultural-objects/ui/single-cultural-object-page";

type Params = {
  slug: string;
};

type PageProps = {
  cms: CulturalObject;
};

const Page = (props: PageProps) => {
  const { cms } = props;

  return <SingleCulturalObjectPage culturalObject={cms} />;
};

export const getServerSideProps: GetServerSideProps<{}, Params> = async (
  context,
) => {
  const { res } = context;
  const { slug } = context.params!;

  return await loadPageWithGlobal(
    async () => {
      const { culturalObject } = await getCulturalObjectPage(slug);

      return {
        ...culturalObject,
      };
    },
    { res },
  );
};

export default Page;
